import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 0H3C1.3 0 0 1.271 0 2.933v15.641c0 .391.2.782.6.88.1.098.3.098.4.098.3 0 .5-.098.7-.293l3.7-3.617H17c1.7 0 3-1.271 3-2.933V2.933C20 1.271 18.7 0 17 0m1 12.709c0 .586-.4.977-1 .977H5c-.3 0-.5.098-.7.294L2 16.228V2.933c0-.587.4-.978 1-.978h14c.6 0 1 .391 1 .978zm-7-4.888c0 .54-.448.977-1 .977s-1-.437-1-.977a.99.99 0 0 1 1-.978.99.99 0 0 1 1 .978m4 0c0 .54-.448.977-1 .977s-1-.437-1-.977a.99.99 0 0 1 1-.978.99.99 0 0 1 1 .978m-8 0c0 .54-.448.977-1 .977s-1-.437-1-.977a.99.99 0 0 1 1-.978.99.99 0 0 1 1 .978"
    }, null, -1)
  ]))]))
}
export default { render: render }